//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import Switch from 'react-switch';
import * as Yup from 'yup';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import SelectInput from '../../components/Inputs/SelectInput';
import Toast from '../../components/Toasts/Toast';
import { objectsConstants } from '../../constants/objects.constants';
import {
  hasClienteComPA,
  isAdmin,
  isAdminBio,
  isAprovador,
  isPontoAtendimento,
  isSudo,
} from '../../helpers/permissions.helper';
import {
  getStepQuantidade,
  normalizarQuantidadeDigitada,
  quantidadeComoNumero,
} from '../../helpers/quantidade.helper';
import { clienteService } from '../../services/cliente.service';
import { mapaProdutosService } from '../../services/mapaProdutos.service';
import { pedidoEmMapaService } from '../../services/pedidoEmMapa.service';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { userService } from '../../services/user.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import CpfInput from '../../components/Inputs/CpfInput';
import { categoriaProdutoService } from '../../services/categoriaProduto.service';
import FormInput from '../../components/Inputs/FormInput';
import { pedidosService } from '../../services/pedidos.service';
import { isValidCPF } from '../../components/Utils/cpfUtils';
import { executarComConfirmacaoInventario } from '../../helpers/inventario.helper';
import { produtoService } from '../../services/produto.service';

const buildValidationSchema = (isSudoFlag, isPontoFlag) => {
  return Yup.object().shape({
    cliente: isSudoFlag
      ? Yup.object()
          .required('Cliente é obrigatório')
          .nullable()
      : Yup.mixed().nullable(),
    pontoAtendimentoId: isPontoFlag
      ? Yup.mixed().nullable()
      : Yup.string()
          .required('PA é obrigatório')
          .nullable(),
    responsavel: Yup.string()
      .nullable()
      .required('Nome do responsável é obrigatório'),
    cpfResponsavel: Yup.string()
      .nullable()
      .required('CPF Obrigatório')
      .test('cpf-valido', 'CPF inválido', (value) => {
        if (!value) return false;
        return isValidCPF(value);
      }),
    produtos: Yup.array()
      .min(1, 'Deve haver ao menos 1 produto no pedido')
      .of(
        Yup.object().shape({
          produto: Yup.object()
            .required('Produto obrigatório')
            .typeError('Produto obrigatório'),
          limiteMaximo: Yup.number()
            .typeError('Limite inválido')
            .min(1, 'Mínimo 1')
            .required(),
          estoqueAtual: Yup.number()
            .typeError('Informe o estoque atual')
            .min(0, 'Não pode ser negativo')
            .required(),
          qtdSolicitar: Yup.number()
            .typeError('Informe a quantidade')
            .when('produto', (produto, schema) => {
              if (produto && produto.bloqueado) {
                return schema.notRequired();
              }
              return schema
                .required('Informe a quantidade')
                .test(
                  'nao-ultrapassa-limite',
                  'Estoque + solicitar não pode ultrapassar limite máximo',
                  function(value) {
                    const parent = this && this.parent ? this.parent : {};
                    const estoqueAtual = parent.estoqueAtual;
                    const limiteMaximo = parent.limiteMaximo;
                    return (
                      (estoqueAtual || 0) + (value || 0) <= (limiteMaximo || 0)
                    );
                  },
                );
            }),
        }),
      ),
  });
};

const obterProdutosSemSaldo = (produtos = []) =>
  (produtos || []).filter((item) => item && item.temEstoque === false);

const criarAvisoProdutosSemSaldo = (produtosSemSaldo = []) => {
  const quantidade = produtosSemSaldo.length;
  if (!quantidade) return null;

  return `Atenção: ${quantidade} ${
    quantidade === 1 ? 'item está' : 'itens estão'
  } sem saldo e ${
    quantidade === 1 ? 'será retirado' : 'serão retirados'
  } do pedido ao final.`;
};

class PedidoEmMapaEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    const user = userService.getCurrentUser();
    this.formikRef = React.createRef();
    this.state = {
      entity: {
        produtos: [],
        cliente: isSudo() ? null : user && user.cliente ? user.cliente : null,
        pontoAtendimentoId: isPontoAtendimento()
          ? user && user.pontoAtendimento && user.pontoAtendimento.id
            ? user.pontoAtendimento.id
            : null
          : null,
        atualizou: false,
        urgente: false,
        justificativaRecusa: '',
        tipoPedido: 'MAPA',
        grupoPedido: 'ALMOXARIFADO',
      },
      categorias: [],
      categoriasSelecionadas: [],
      estoquePorProduto: {},
      todosProdutos: [],
      produtoNovoSelecionado: null,
      verificandoProdutoNovo: false,
      salvandoPedidoEmMapa: false,
      integracaoEmAndamento: false,
      integracaoStatus: null,
      integracaoUltimoErro: null,
    };
    this._integracaoPollTimer = null;
    this._mounted = false;
  }

  iniciarAcompanhamentoIntegracao = (id) => {
    if (!id || !this._mounted) return;

    if (this._integracaoPollTimer) {
      clearTimeout(this._integracaoPollTimer);
      this._integracaoPollTimer = null;
    }

    let tentativas = 0;
    const consultar = async () => {
      if (!this._mounted) return;

      try {
        const response = await pedidoEmMapaService.consultarStatusIntegracao(
          id,
        );
        const status = response && response.data ? response.data : null;

        if (!status || !this._mounted) return;

        this.setState((prevState) => ({
          entity: {
            ...prevState.entity,
            status: status.status || prevState.entity.status,
            numeroPedido: status.numeroPedido || prevState.entity.numeroPedido,
            integracaoEmAndamento: status.integracaoEmAndamento,
            integracaoStatus: status.integracaoStatus,
            integracaoUltimoErro: status.integracaoUltimoErro,
            integracaoIniciadaAt: status.integracaoIniciadaAt,
            integracaoFinalizadaAt: status.integracaoFinalizadaAt,
          },
          integracaoEmAndamento: !!status.integracaoEmAndamento,
          integracaoStatus: status.integracaoStatus,
          integracaoUltimoErro: status.integracaoUltimoErro,
        }));

        if (!status.integracaoEmAndamento) {
          if (status.integracaoStatus === 'CONCLUIDA' && status.numeroPedido) {
            this.props.success({
              message: `Pedido aprovado. Nº do pedido: ${status.numeroPedido}.`,
            });
          }
          return;
        }

        tentativas += 1;
        if (tentativas < 600 && this._mounted) {
          this._integracaoPollTimer = setTimeout(consultar, 3000);
        }
      } catch (error) {
        // Falhas transitórias de consulta não reenviam a aprovação.
        tentativas += 1;
        if (tentativas < 600 && this._mounted) {
          this._integracaoPollTimer = setTimeout(consultar, 3000);
        }
      }
    };

    consultar();
  };

  carregarPedidoParaFormulario = async (id, duplicando = false) => {
    const user = userService.getCurrentUser();

    this.props.loading(true, 'Carregando pedido...');

    try {
      const response = await pedidoEmMapaService.doGet(id);
      const pedido = response && response.data ? response.data : null;

      if (!pedido) {
        this.props.loading(false);
        return;
      }

      const pedidoProdutosMap = {};

      (pedido.produtos || []).forEach((p) => {
        const idProduto =
          p && p.idProduto
            ? p.idProduto
            : p && p.produto && p.produto.id
            ? p.produto.id
            : null;

        if (!idProduto) return;

        const existente = pedidoProdutosMap[idProduto];

        if (existente) {
          existente.qtdSolicitar += quantidadeComoNumero(p.qtdSolicitar, 0);
          existente.estoqueAtual += quantidadeComoNumero(p.estoqueAtual, 0);
        } else {
          pedidoProdutosMap[idProduto] = {
            qtdSolicitar: quantidadeComoNumero(p.qtdSolicitar, 0),
            estoqueAtual: quantidadeComoNumero(p.estoqueAtual, 0),
            produto: p && p.produto ? p.produto : null,
          };
        }
      });

      // Não enviar os IDs do pedido como query string: pedidos maiores
      // ultrapassam o limite de cabeçalho do servidor junto com o token.
      // O mapa completo também permite preservar os produtos extras abaixo.
      const mapaResp = await mapaProdutosService.findMapaPedido(
        pedido.pontoAtendimentoId,
      );
      const mapa = mapaResp && mapaResp.data ? mapaResp.data : {};

      const mapaProdutos = mapa && mapa.produtos ? mapa.produtos : [];

      const idsMapa = (mapaProdutos || [])
        .map((mp) => (mp && mp.idProduto ? mp.idProduto : null))
        .filter((x) => x !== null && x !== undefined);

      const produtosDoMapa = (mapaProdutos || []).map((item) => {
        const pedidoProd = pedidoProdutosMap[item.idProduto] || {};

        return {
          produto: item.produto,
          idProduto: item.idProduto,
          limiteMaximo: item.limiteMaximo,
          estoqueAtual: quantidadeComoNumero(pedidoProd.estoqueAtual, 0),
          qtdSolicitar: quantidadeComoNumero(pedidoProd.qtdSolicitar, 0),
          temEstoque: isPontoAtendimento() ? true : undefined,
          estoqueTotal: isPontoAtendimento() ? null : undefined,
          adicionadoPosteriormente: false,
        };
      });

      const produtosExtras = Object.keys(pedidoProdutosMap)
        .filter((idProduto) => idsMapa.indexOf(idProduto) === -1)
        .map((idProduto) => {
          const info = pedidoProdutosMap[idProduto] || {};

          return {
            produto: info.produto,
            idProduto: idProduto,
            limiteMaximo: 999999,
            estoqueAtual: quantidadeComoNumero(info.estoqueAtual, 0),
            qtdSolicitar: quantidadeComoNumero(info.qtdSolicitar, 0),
            temEstoque: isPontoAtendimento() ? true : undefined,
            estoqueTotal: isPontoAtendimento() ? null : undefined,
            adicionadoPosteriormente: true,
          };
        });

      const produtos = duplicando
        ? produtosDoMapa
        : [].concat(produtosDoMapa, produtosExtras);

      const codigoDepositante =
        mapa && mapa.cliente && mapa.cliente.codigoDepositante
          ? mapa.cliente.codigoDepositante
          : null;

      const catResp = await categoriaProdutoService.findByCodigoDepositante(
        codigoDepositante,
      );
      const categorias = (catResp && catResp.data ? catResp.data : []) || [];

      categorias.push({
        descricao: 'Sem categoria',
        codigoFamilia: 0,
      });

      const entityAtualizada = {
        id: duplicando ? null : pedido.id,
        cliente: pedido.cliente || (isSudo() ? null : user && user.cliente),
        pontoAtendimentoId: pedido.pontoAtendimentoId,
        produtos: produtos,
        ativo: pedido.ativo,
        status: duplicando ? 'CRIADO' : pedido.status,
        numeroPedido: duplicando ? null : pedido.numeroPedido,
        urgente: pedido.urgente || false,
        responsavel: pedido.responsavel,
        cpfResponsavel: pedido.cpfResponsavel,
        justificativaRecusa: '',
        tipoPedido: 'MAPA',
        grupoPedido: pedido.grupoPedido || 'ALMOXARIFADO',
        integracaoEmAndamento: duplicando
          ? false
          : !!pedido.integracaoEmAndamento,
        integracaoStatus: duplicando ? null : pedido.integracaoStatus,
        integracaoUltimoErro: duplicando ? null : pedido.integracaoUltimoErro,
        integracaoIniciadaAt: duplicando ? null : pedido.integracaoIniciadaAt,
        integracaoFinalizadaAt: duplicando
          ? null
          : pedido.integracaoFinalizadaAt,
      };

      // O catálogo para inclusão é consultado sob demanda no campo de busca.
      // A abertura do pedido não precisa carregar todos os produtos do cliente.
      const todosProdutos = [];

      const temExtras = !duplicando && (produtosExtras || []).length > 0;

      let categoriasSelecionadas = (categorias || []).map((c) => c.descricao);

      if (temExtras && categoriasSelecionadas.indexOf('Sem categoria') === -1) {
        categoriasSelecionadas = [].concat(categoriasSelecionadas, [
          'Sem categoria',
        ]);
      }

      this.setState(
        {
          entity: entityAtualizada,
          categorias: categorias,
          categoriasSelecionadas: categoriasSelecionadas,
          atualizou: true,
          todosProdutos: todosProdutos,
        },
        async () => {
          if (
            !isPontoAtendimento() &&
            this.formikRef.current &&
            this.formikRef.current.setFieldValue
          ) {
            const produtosComQtd = (entityAtualizada.produtos || []).filter(
              (p) => p && p.qtdSolicitar && p.qtdSolicitar > 0,
            );

            if (produtosComQtd.length > 0) {
              await this.verificarEstoqueProdutosAsync(
                produtosComQtd,
                this.formikRef.current.setFieldValue,
              );
            }
          }

          this.props.loading(false);

          if (!duplicando && pedido.integracaoEmAndamento) {
            this.iniciarAcompanhamentoIntegracao(pedido.id);
          }
        },
      );
    } catch (e) {
      console.error(e);
      this.props.loading(false);
      this.props.error({
        message: 'Erro ao carregar pedido para cópia.',
      });
    }
  };
  componentDidMount() {
    this._mounted = true;
    const user = userService.getCurrentUser();
    const id = _.get(this.props.match, 'params.id');
    const copiarDeId = _.get(this.props.location, 'state.copiarDeId');

    if (copiarDeId) {
      this.carregarPedidoParaFormulario(copiarDeId, true);
      return;
    }
    if (id) {
      this.carregarPedidoParaFormulario(id, false);
    } else if (
      isPontoAtendimento() &&
      user &&
      user.pontoAtendimento &&
      user.pontoAtendimento.id
    ) {
      this.buscarMapaPorPA(user.pontoAtendimento.id);
    } else {
      this.setState({ atualizou: true });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this._integracaoPollTimer) {
      clearTimeout(this._integracaoPollTimer);
      this._integracaoPollTimer = null;
    }
  }

  buscarMapaPorPA = async (idPontoAtendimento) => {
    if (!idPontoAtendimento) return;

    this.props.loading(true, 'Buscando Mapa...');

    try {
      const response = await mapaProdutosService.findMapaPedido(
        idPontoAtendimento,
      );
      const mapa = response && response.data ? response.data : null;

      const produtos = ((mapa && mapa.produtos) || []).map((item) => ({
        produto: item.produto,
        idProduto: item.idProduto,
        limiteMaximo: item.limiteMaximo,
        estoqueAtual: 0,
        qtdSolicitar: 0,
        temEstoque: true,
        estoqueTotal: isPontoAtendimento() ? null : undefined,
      }));

      const codigoDepositante =
        mapa && mapa.cliente && mapa.cliente.codigoDepositante
          ? mapa.cliente.codigoDepositante
          : null;

      const catResp = await categoriaProdutoService.findByCodigoDepositante(
        codigoDepositante,
      );
      const categorias = (catResp && catResp.data ? catResp.data : []) || [];

      categorias.push({
        descricao: 'Sem categoria',
        codigoFamilia: 0,
      });

      const categoriasSelecionadas = categorias.map((c) => c.descricao);

      // O catálogo para inclusão é consultado sob demanda no campo de busca.
      const todosProdutos = [];

      this.setState(
        {
          entity: {
            produtos: produtos,
            cliente: {
              codigoCliente: mapa ? mapa.codigoCliente : null,
              nomeFantasia: mapa ? mapa.clienteNomeFantasia : null,
              label: mapa && mapa.cliente ? mapa.cliente.label : null,
            },
            pontoAtendimentoId: idPontoAtendimento,
            status: mapa ? mapa.status : null,
            tipoPedido: 'MAPA',
            grupoPedido: 'ALMOXARIFADO',
          },
          categorias: categorias,
          categoriasSelecionadas: categoriasSelecionadas,
          atualizou: true,
          todosProdutos: todosProdutos,
        },
        async () => {
          await new Promise((resolve) => setTimeout(resolve, 2000));
          this.props.loading(false);
        },
      );
    } catch (error) {
      console.error('Erro ao buscar mapa do PA:', error);
      this.props.loading(false);

      this.setState((prevState) => ({
        entity: {
          ...prevState.entity,
          produtos: [],
          pontoAtendimentoId: idPontoAtendimento,
          status: null,
        },
        categorias: [],
        categoriasSelecionadas: [],
        atualizou: true,
      }));

      if (this.formikRef.current && this.formikRef.current.setFieldValue) {
        this.formikRef.current.setFieldValue('produtos', []);
        this.formikRef.current.setFieldValue(
          'pontoAtendimentoId',
          idPontoAtendimento,
        );
        this.formikRef.current.setFieldValue('status', null);
      }

      this.props.error({
        message: 'Não existe MAPA cadastrado para esse Ponto de Atendimento',
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const paMudouECarregouProdutos =
      !isPontoAtendimento() &&
      this.state.entity &&
      this.state.entity.produtos &&
      this.state.entity.produtos.length > 0 &&
      prevState.entity &&
      prevState.entity.produtos &&
      prevState.entity.produtos.length === 0;

    if (paMudouECarregouProdutos) {
      const refAtual = this.formikRef.current;
      if (refAtual && refAtual.setFieldValue) {
        if (!this._verificandoEstoque) {
          this._verificandoEstoque = true;
        }
      }
    } else {
      if (isPontoAtendimento()) {
        this.props.loading(false);
      }
    }
  }

  handleQuantidadeChange = (setFieldValue, fieldName, value, produto) => {
    setFieldValue(fieldName, normalizarQuantidadeDigitada(value, produto));
  };

  verificarEstoqueProdutosAsync = async (produtos, setFieldValue) => {
    if (isPontoAtendimento()) {
      const atualizados = (produtos || []).map((item) => ({
        ...item,
        temEstoque: true,
        estoqueTotal: null,
      }));
      setFieldValue('produtos', atualizados);
      return;
    }

    try {
      const payload = (produtos || [])
        .filter((p) => p && p.idProduto && p.qtdSolicitar > 0)
        .map((p) => ({
          idProduto: p.idProduto,
          codigoOmie:
            p.produto && p.produto.codigoOmni ? p.produto.codigoOmni : null,
          qtdSolicitar: p.qtdSolicitar,
        }));

      const resp = await pedidosService.verificarEstoqueLote(payload);
      const estoqueMap = _.keyBy(
        resp && resp.data ? resp.data : [],
        'idProduto',
      );

      const atualizados = (produtos || []).map((item) => {
        const estoqueInfo = estoqueMap[item.idProduto] || {};
        const temEstoque = estoqueInfo.temEstoque || false;
        const estoqueTotal = estoqueInfo.estoqueTotal || 0;

        return {
          ...item,
          temEstoque: temEstoque,
          estoqueTotal: estoqueTotal,
          qtdSolicitar: temEstoque ? item.qtdSolicitar : 0,
        };
      });

      setFieldValue('produtos', atualizados);
    } catch (error) {
      console.error('Erro ao verificar estoque em lote:', error);
    }
  };

  filterProdutosDisponiveis = (todosProdutos, valores) => {
    const idsSelecionados = (valores && valores.produtos
      ? valores.produtos
      : []
    )
      .map((p) => {
        if (!p) return null;
        return p.idProduto || (p.produto && p.produto.id) || null;
      })
      .filter((id) => id !== null && id !== undefined);

    return (todosProdutos || []).filter(
      (p) => p && !idsSelecionados.includes(p.id),
    );
  };

  // ✅ FIX DEFINITIVO: /getEstoque/{codigoOmie} retorna List<EstoqueAlcisVO>
  // Soma direta de quantidadeDisponivel (estoque disponível).
  extrairEstoqueTotalDoFindEstoque = (resp) => {
    const data = resp && resp.data ? resp.data : null;
    if (!Array.isArray(data)) return 0;

    return data.reduce((acc, item) => {
      const qtd =
        item && typeof item.quantidadeDisponivel === 'number'
          ? item.quantidadeDisponivel
          : parseFloat(
              item && item.quantidadeDisponivel ? item.quantidadeDisponivel : 0,
            );

      return acc + (isNaN(qtd) ? 0 : qtd);
    }, 0);
  };

  adicionarProdutoExtraComEstoque = async (
    produtoSelecionado,
    values,
    setFieldValue,
  ) => {
    if (!produtoSelecionado || !produtoSelecionado.id) return;

    if (!produtoSelecionado.codigoOmni) {
      this.props.error({
        message:
          'Produto selecionado sem código Omie (codigoOmni). Não é possível consultar estoque.',
      });
      return;
    }

    const jaExiste = (values && values.produtos ? values.produtos : []).some(
      (p) => {
        const id = p
          ? p.idProduto || (p.produto && p.produto.id) || null
          : null;
        return id === produtoSelecionado.id;
      },
    );

    if (jaExiste) {
      this.props.error({ message: 'Produto já está na lista do pedido.' });
      return;
    }

    // PA não valida estoque aqui (regra já existente)
    if (isPontoAtendimento()) {
      const novoItem = {
        produto: produtoSelecionado,
        idProduto: produtoSelecionado.id,
        limiteMaximo: 999999,
        estoqueAtual: 0,
        qtdSolicitar: 0,
        temEstoque: true,
        estoqueTotal: null,
      };
      const novaLista = [].concat(
        values && values.produtos ? values.produtos : [],
        [novoItem],
      );
      setFieldValue('produtos', novaLista);
      this.setState({ produtoNovoSelecionado: null });
      return;
    }

    try {
      this.setState({ verificandoProdutoNovo: true });

      const resp = await pedidosService.findEstoque(produtoSelecionado);
      const estoqueTotal = this.extrairEstoqueTotalDoFindEstoque(resp);

      if (!estoqueTotal || estoqueTotal <= 0) {
        this.props.error({
          message: 'Produto sem estoque. Não é possível adicioná-lo ao pedido.',
        });
        return;
      }

      const novoItem = {
        produto: produtoSelecionado,
        idProduto: produtoSelecionado.id,
        limiteMaximo: 999999,
        estoqueAtual: 0,
        qtdSolicitar: 0,
        temEstoque: true,
        estoqueTotal: estoqueTotal,
      };

      const novaLista = [].concat(
        values && values.produtos ? values.produtos : [],
        [novoItem],
      );

      setFieldValue('produtos', novaLista);
      this.setState({ produtoNovoSelecionado: null });
    } catch (e) {
      console.error('Erro ao consultar estoque (findEstoque):', e);
      this.props.error({ message: 'Erro ao verificar estoque do produto.' });
    } finally {
      this.setState({ verificandoProdutoNovo: false });
    }
  };

  render() {
    const entity = this.state.entity;
    const isEdit = !!(this.state.entity && this.state.entity.id);

    const validationSchema = buildValidationSchema(
      isSudo(),
      isPontoAtendimento(),
    );

    const isFinalizado =
      entity &&
      (((entity.status === 'APROVADO' || entity.status === 'RECUSADO') &&
        !isSudo()) ||
        entity.integracaoEmAndamento ||
        entity.integracaoStatus === 'AGUARDANDO_RECONCILIACAO');
    const integracaoEmAndamento = !!(entity && entity.integracaoEmAndamento);
    const podeAprovar = isSudo() || isAdmin() || isAprovador();

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Pedido em Mapa"
          subTitle=" "
          canBack={true}
        />
        <Formik
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          innerRef={this.formikRef}
          onSubmit={async (values, actions) => {
            if (
              this.state.salvandoPedidoEmMapa ||
              this.state.integracaoEmAndamento
            ) {
              return;
            }

            this.setState({ salvandoPedidoEmMapa: true });
            this.props.loading(true, 'Enviando...');

            const statusFinal = values ? values.status : null;
            const isRecusado = statusFinal === 'RECUSADO';
            const isEdicao = !!(values && values.id);

            const produtosComQtdValida = (values && values.produtos
              ? values.produtos
              : []
            ).filter((p) => {
              const bloqueado = p && p.produto && p.produto.bloqueado;
              if (bloqueado) return false;

              const qtd = quantidadeComoNumero(
                p && p.qtdSolicitar ? p.qtdSolicitar : 0,
                0,
              );

              return !isNaN(qtd) && qtd > 0;
            });

            if (!isRecusado && produtosComQtdValida.length === 0) {
              this.props.loading(false);
              this.setState({ salvandoPedidoEmMapa: false });

              this.props.error({
                message:
                  'Informe ao menos 1 produto com quantidade maior que zero para salvar o pedido.',
              });

              actions.setSubmitting(false);
              return;
            }

            if (!isRecusado && isEdicao) {
              const produtosInvalidos = (values && values.produtos
                ? values.produtos
                : []
              ).filter((p) => {
                if (isPontoAtendimento()) return false;

                const qtd =
                  quantidadeComoNumero(
                    p && p.qtdSolicitar ? p.qtdSolicitar : 0,
                    0,
                  ) || 0;

                const estoqueTotal =
                  quantidadeComoNumero(
                    p && p.estoqueTotal ? p.estoqueTotal : 0,
                    0,
                  ) || 0;

                return qtd > estoqueTotal;
              });

              if (produtosInvalidos.length > 0) {
                this.props.loading(false);
                this.setState({ salvandoPedidoEmMapa: false });

                this.props.error({
                  message:
                    'Um ou mais produtos têm quantidade solicitada maior que o estoque.',
                });

                actions.setSubmitting(false);
                return;
              }

              if (values && values.status === 'APROVADO') {
                const todasZeradas = (values && values.produtos
                  ? values.produtos
                  : []
                ).every((p) => {
                  const qtd = quantidadeComoNumero(
                    p && p.qtdSolicitar ? p.qtdSolicitar : 0,
                    0,
                  );

                  return isNaN(qtd) || qtd === 0;
                });

                if (todasZeradas) {
                  this.props.loading(false);
                  this.setState({ salvandoPedidoEmMapa: false });

                  this.props.error({
                    message:
                      'Não é possível aprovar o pedido. Todas as quantidades estão zeradas.',
                  });

                  actions.setSubmitting(false);
                  return;
                }
              }
            }

            try {
              const entidade = _.cloneDeep(values);
              entidade.tipoPedido = objectsConstants.TIPO_PEDIDO_EM_MAPA;

              if (!entidade.grupoPedido) {
                entidade.grupoPedido = 'ALMOXARIFADO';
              }

              if (!isSudo()) {
                const userAtual = userService.getCurrentUser();
                entidade.cliente =
                  userAtual && userAtual.cliente
                    ? userAtual.cliente
                    : entidade.cliente;
              }

              entidade.produtos = produtosComQtdValida;

              const response = await executarComConfirmacaoInventario(
                pedidoEmMapaService.doSave,
                entidade,
              );
              if (response && response.inventarioBloqueado) {
                this.props.loading(false);
                actions.setSubmitting(false);
                this.setState({ salvandoPedidoEmMapa: false });
                return;
              }
              const salvo = response && response.data ? response.data : null;
              const numeroPedido =
                salvo && salvo.numeroPedido ? salvo.numeroPedido : null;

              if (salvo && salvo.integracaoEmAndamento) {
                const entityProcessando = {
                  ...this.state.entity,
                  status: salvo.status || 'CRIADO',
                  numeroPedido:
                    salvo.numeroPedido || this.state.entity.numeroPedido,
                  integracaoEmAndamento: true,
                  integracaoStatus: salvo.integracaoStatus || 'PROCESSANDO',
                  integracaoUltimoErro: salvo.integracaoUltimoErro || null,
                  integracaoIniciadaAt: salvo.integracaoIniciadaAt,
                  integracaoFinalizadaAt: salvo.integracaoFinalizadaAt,
                };

                this.setState(
                  {
                    entity: entityProcessando,
                    integracaoEmAndamento: true,
                    integracaoStatus: entityProcessando.integracaoStatus,
                    integracaoUltimoErro: null,
                  },
                  () => this.iniciarAcompanhamentoIntegracao(salvo.id),
                );
                this.props.loading(false);
                actions.setSubmitting(false);
                return;
              }

              this.props.loading(false);
              this.props.history.push('/pedidoEmMapa');
              actions.setSubmitting(false);

              this.props.success({
                message: numeroPedido
                  ? `Mapa salvo. Nº do pedido: ${numeroPedido}.`
                  : 'Mapa de Produtos salvo com sucesso.',
              });
            } catch (e) {
              console.error(e);
              actions.setSubmitting(false);
              this.props.loading(false);

              const status = e && e.response ? e.response.status : null;
              const mapaConflitado =
                status === 409 &&
                e.response &&
                e.response.data &&
                e.response.data.id
                  ? e.response.data
                  : null;

              if (
                mapaConflitado &&
                (mapaConflitado.integracaoEmAndamento ||
                  mapaConflitado.integracaoStatus ===
                    'AGUARDANDO_RECONCILIACAO')
              ) {
                const aguardandoReconciliacao =
                  mapaConflitado.integracaoStatus ===
                  'AGUARDANDO_RECONCILIACAO';
                this.setState(
                  (prevState) => ({
                    entity: {
                      ...prevState.entity,
                      status: mapaConflitado.status || prevState.entity.status,
                      numeroPedido:
                        mapaConflitado.numeroPedido ||
                        prevState.entity.numeroPedido,
                      integracaoEmAndamento: !!mapaConflitado.integracaoEmAndamento,
                      integracaoStatus:
                        mapaConflitado.integracaoStatus || 'PROCESSANDO',
                      integracaoUltimoErro: null,
                    },
                    integracaoEmAndamento: !!mapaConflitado.integracaoEmAndamento,
                    integracaoStatus:
                      mapaConflitado.integracaoStatus || 'PROCESSANDO',
                    integracaoUltimoErro: null,
                  }),
                  () => {
                    if (!aguardandoReconciliacao) {
                      this.iniciarAcompanhamentoIntegracao(mapaConflitado.id);
                    }
                  },
                );
                this.props.success({
                  message:
                    aguardandoReconciliacao
                      ? 'Este mapa aguarda reconciliação. Não reenvie o pedido.'
                      : 'Este mapa já está sendo processado. Acompanhe o status nesta tela.',
                });
                return;
              }

              let message = _.get(e, 'response.data');

              if (message && typeof message !== 'string') {
                message =
                  _.get(message, 'message') || _.get(message, 'error') || null;
              }

              this.props.error({
                message:
                  message ||
                  (status === 409
                    ? 'Este mapa ja esta em aprovacao ou ja foi processado. Atualize a tela para conferir o status.'
                    : 'Erro ao salvar o pedido. Verifique os dados.'),
              });
            } finally {
              this.setState({ salvandoPedidoEmMapa: false });
            }
          }}
        >
          {(formikProps) => {
            this.formikRef.current = formikProps;

            const values = formikProps.values;
            const errors = formikProps.errors;
            const touched = formikProps.touched;
            const handleChange = formikProps.handleChange;
            const handleSubmit = formikProps.handleSubmit;
            const isSubmitting = formikProps.isSubmitting;
            const setFieldValue = formikProps.setFieldValue;
            const produtosSemSaldo = obterProdutosSemSaldo(values.produtos);
            const avisoProdutosSemSaldo = criarAvisoProdutosSemSaldo(
              produtosSemSaldo,
            );
            const exibirAvisoProdutosSemSaldo =
              isEdit &&
              podeAprovar &&
              values.status === 'CRIADO' &&
              !integracaoEmAndamento &&
              Boolean(avisoProdutosSemSaldo);

            const podeAdicionarProduto =
              isEdit &&
              values &&
              !isFinalizado &&
              !this.state.salvandoPedidoEmMapa &&
              hasClienteComPA() &&
              (isSudo() || isAdmin() || isAprovador() || isAdminBio());
            const produtosDisponiveis = this.filterProdutosDisponiveis(
              this.state.todosProdutos || [],
              values,
            );

            return (
              <form onSubmit={handleSubmit} noValidate>
                {exibirAvisoProdutosSemSaldo && (
                  <div className="alert alert-danger mx-3 mt-3" role="alert">
                    {avisoProdutosSemSaldo}
                  </div>
                )}
                {integracaoEmAndamento && (
                  <div className="alert alert-warning mx-3 mt-3" role="status">
                    Aprovação em processamento. O pedido está sendo integrado;
                    não é necessário reenviar.
                  </div>
                )}
                {!integracaoEmAndamento &&
                  entity &&
                  entity.integracaoStatus === 'AGUARDANDO_RECONCILIACAO' && (
                    <div className="alert alert-warning mx-3 mt-3" role="status">
                      O Omie aceitou o pedido, mas a gravação local precisa ser
                      reconciliada. Não reenvie; aguarde a regularização.
                    </div>
                  )}
                {!integracaoEmAndamento &&
                  entity &&
                  entity.integracaoStatus === 'ERRO' && (
                    <div className="alert alert-danger mx-3 mt-3" role="alert">
                      A aprovação não foi concluída.{' '}
                      {entity.integracaoUltimoErro ||
                        'Verifique os dados e tente novamente.'}
                    </div>
                  )}
                <div className="flex-column">
                  <Toast />
                  <div className="cardSeculus d-flex flex-column mb-0">
                    <div className="form-row">
                      {isSudo() && (
                        <div className="form-group col-md-6">
                          <FormSelectInput
                            disabled={
                              isFinalizado || this.state.salvandoPedidoEmMapa
                            }
                            name="cliente"
                            id="cliente"
                            label="Cliente"
                            placeholder="Selecione o cliente"
                            valueKey="codigoCliente"
                            labelKey="label"
                            required={true}
                            returnFullObject={true}
                            service={async () => {
                              const resp = await clienteService.findAll();
                              return {
                                data: (resp && resp.data
                                  ? resp.data
                                  : []
                                ).filter((c) =>
                                  Boolean(c.possuiPontoAtendimento),
                                ),
                              };
                            }}
                            onChange={(name, value) => {
                              setFieldValue(name, value);
                              setFieldValue('pontoAtendimentoId', null);
                              setFieldValue('produtos', []);
                            }}
                            value={values.cliente}
                            messageValidate={touched.cliente && errors.cliente}
                          />
                        </div>
                      )}

                      {(isSudo() || isAdmin() || isAprovador()) &&
                        values.cliente && (
                          <div className="form-group col-md-6">
                            <FormSelectInput
                              disabled={
                                isFinalizado || this.state.salvandoPedidoEmMapa
                              }
                              key={values.cliente.codigoCliente}
                              name="pontoAtendimentoId"
                              id="pontoAtendimentoId"
                              label="Ponto de Atendimento"
                              placeholder="Selecione o PA"
                              valueKey="id"
                              labelKey="nome"
                              required={true}
                              returnFullObject={false}
                              parent={values.cliente}
                              service={pontoAtendimentoService.findAllByCliente}
                              onChange={(name, value) => {
                                setFieldValue(name, value);
                                setFieldValue('produtos', []);
                                this.buscarMapaPorPA(value);
                              }}
                              value={values.pontoAtendimentoId}
                              messageValidate={errors.pontoAtendimentoId}
                            />
                          </div>
                        )}

                      {(isSudo() || isAdmin() || isAprovador()) &&
                        entity &&
                        entity.id && (
                          <div className="form-group col-md-6">
                            <SelectInput
                              name="status"
                              id="status"
                              label="Status"
                              placeholder="Selecione o novo status"
                              valueKey="value"
                              labelKey="label"
                              noSize={true}
                              returnFullObject={false}
                              isMulti={false}
                              searchable={false}
                              allowSelectAll={false}
                              options={objectsConstants.STATUS_PEDIDO_DEVOLUCAO}
                              messageValidate={errors.status}
                              disabled={
                                isFinalizado || this.state.salvandoPedidoEmMapa
                              }
                              value={values.status}
                              className={`select-status ${values.status &&
                                values.status.toLowerCase()}`}
                              onChange={(name, value) => {
                                if (this.state.salvandoPedidoEmMapa) {
                                  return;
                                }

                                const statusAnterior = values.status;
                                const statusNovo = value;
                                const finalizando =
                                  statusAnterior === 'CRIADO' &&
                                  (statusNovo === 'APROVADO' ||
                                    statusNovo === 'RECUSADO');

                                if (finalizando) {
                                  const produtosSemSaldo = obterProdutosSemSaldo(
                                    values.produtos,
                                  );
                                  const avisoSemSaldo =
                                    statusNovo === 'APROVADO' &&
                                    criarAvisoProdutosSemSaldo(
                                      produtosSemSaldo,
                                    );

                                  confirmAlert({
                                    customUI: ({ onClose }) => (
                                      <div className="custom-confirm-alert">
                                        <h2>
                                          {avisoSemSaldo
                                            ? 'Atenção'
                                            : 'Confirmação'}
                                        </h2>
                                        <p>
                                          {avisoSemSaldo && (
                                            <React.Fragment>
                                              <strong className="text-danger">
                                                {avisoSemSaldo}
                                              </strong>
                                              <br />
                                            </React.Fragment>
                                          )}
                                          Ao aprovar ou recusar, o pedido não
                                          poderá mais ser alterado. Deseja
                                          continuar?
                                        </p>
                                        <div className="d-flex justify-content-around mt-4">
                                          <button
                                            className="btn btn-secondary btn30 white"
                                            onClick={onClose}
                                          >
                                            Cancelar
                                          </button>
                                          <button
                                            className="btn btn-danger btn30"
                                            onClick={() => {
                                              setFieldValue(name, value);
                                              onClose();
                                            }}
                                          >
                                            Confirmar
                                          </button>
                                        </div>
                                      </div>
                                    ),
                                  });
                                } else {
                                  setFieldValue(name, value);
                                }
                              }}
                            />
                          </div>
                        )}

                      {(isSudo() || isAdmin() || isAprovador()) && (
                        <div className="form-group col-md-2">
                          <label className="label-nowrap">É urgente?</label>
                          <div>
                            <Switch
                              onChange={(value) =>
                                setFieldValue('urgente', value)
                              }
                              checked={values.urgente || false}
                              onColor={'#0080ff'}
                              offColor={'#d9d9d9'}
                              height={30}
                              width={60}
                              handleDiameter={28}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              activeBoxShadow={'none'}
                              disabled={
                                isFinalizado || this.state.salvandoPedidoEmMapa
                              }
                            />
                          </div>
                        </div>
                      )}
                      <div className="form-group col-md-4">
                        <SelectInput
                          name="grupoPedido"
                          id="grupoPedido"
                          label="Grupo do Pedido"
                          placeholder="Selecione o grupo"
                          valueKey="value"
                          labelKey="label"
                          noSize={true}
                          returnFullObject={false}
                          isMulti={false}
                          searchable={false}
                          allowSelectAll={false}
                          options={objectsConstants.GRUPO_PEDIDO_MAPA}
                          value={values.grupoPedido || 'ALMOXARIFADO'}
                          disabled={
                            isFinalizado || this.state.salvandoPedidoEmMapa
                          }
                          onChange={(name, value) => {
                            setFieldValue('tipoPedido', 'MAPA');
                            setFieldValue(name, value);
                          }}
                        />
                      </div>

                      {values.status === 'RECUSADO' && (
                        <div className="form-group col-md-12">
                          <label htmlFor="justificativaRecusa">
                            Justificativa da Recusa
                          </label>
                          <textarea
                            className="form-control"
                            name="justificativaRecusa"
                            id="justificativaRecusa"
                            rows="3"
                            value={values.justificativaRecusa}
                            onChange={handleChange}
                            disabled={
                              isFinalizado || this.state.salvandoPedidoEmMapa
                            }
                          />
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="mb-2">Categorias</label>
                      <div className="d-flex flex-wrap mb-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary mr-2 mb-2"
                          disabled={this.state.salvandoPedidoEmMapa}
                          onClick={() =>
                            this.setState({
                              categoriasSelecionadas: (
                                this.state.categorias || []
                              ).map((c) => c.descricao),
                            })
                          }
                        >
                          Marcar todos
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary mb-2"
                          disabled={this.state.salvandoPedidoEmMapa}
                          onClick={() =>
                            this.setState({ categoriasSelecionadas: [] })
                          }
                        >
                          Desmarcar todos
                        </button>
                      </div>
                      <div className="d-flex flex-wrap">
                        {(this.state.categorias || [])
                          .filter((cat) => cat && cat.descricao !== '')
                          .map((cat) => (
                            <div key={cat.descricao} className="mr-3 mb-2">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={(
                                    this.state.categoriasSelecionadas || []
                                  ).includes(cat.descricao)}
                                  onChange={(e) => {
                                    const selecionadas =
                                      this.state.categoriasSelecionadas || [];
                                    if (e.target.checked) {
                                      this.setState({
                                        categoriasSelecionadas: [].concat(
                                          selecionadas,
                                          [cat.descricao],
                                        ),
                                      });
                                    } else {
                                      this.setState({
                                        categoriasSelecionadas: selecionadas.filter(
                                          (c) => c !== cat.descricao,
                                        ),
                                      });
                                    }
                                  }}
                                />{' '}
                                {cat.descricao}
                              </label>
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* fim filtro categoria */}

                    <div className="lista-mapa-produto">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="thead-light">
                          <tr>
                            <th>Item</th>
                            <th>Código</th>
                            <th className="w-50">Descrição</th>
                            {!isPontoAtendimento() && <th>Estoque Total</th>}
                            <th>Categoria</th>
                            <th>Unidade Medida</th>
                            <th>Máximo</th>
                            <th className="w100">Estoque Atual</th>
                            <th className="w100">Solicitar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(values.produtos || [])
                            .filter((p) => {
                              const familiaDesc =
                                (p && p.produto && p.produto.descricaoFamilia
                                  ? p.produto.descricaoFamilia
                                  : null) || 'Sem categoria';
                              return (
                                this.state.categoriasSelecionadas || []
                              ).includes(familiaDesc);
                            })
                            .map((item, index) => (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td>
                                  <span
                                    className={
                                      item.temEstoque === false
                                        ? 'text-danger font-weight-bold'
                                        : ''
                                    }
                                  >
                                    {(item.produto &&
                                      item.produto.codigoProduto) ||
                                      'Não informado'}
                                  </span>
                                </td>
                                <td className="w-50">
                                  <span
                                    className={
                                      item.temEstoque === false
                                        ? 'text-danger font-weight-bold'
                                        : ''
                                    }
                                  >
                                    {(item.produto && item.produto.descricao) ||
                                      'Não informado'}
                                  </span>
                                  {item.adicionadoPosteriormente && (
                                    <span className="badge custom-badge ml-2 badge-inline">
                                      Adicionado na aprovação
                                    </span>
                                  )}
                                  {item.temEstoque === false && (
                                    <span className="text-red">
                                      {' '}
                                      (Sem estoque)
                                    </span>
                                  )}
                                  {item.produto && item.produto.bloqueado && (
                                    <span className="text-red">
                                      {' '}
                                      (Produto Bloqueado)
                                    </span>
                                  )}
                                </td>
                                {!isPontoAtendimento() && (
                                  <td className="text-center">
                                    {item.estoqueTotal != null
                                      ? item.estoqueTotal
                                      : '-'}
                                  </td>
                                )}
                                <td>
                                  {(item.produto &&
                                    item.produto.descricaoFamilia) ||
                                    'Não Informado'}
                                </td>
                                <td className="text-center">
                                  {(item.produto &&
                                    item.produto.unidadeMedida) ||
                                    'Não informado'}
                                </td>
                                <td className="text-center">
                                  {item.limiteMaximo}
                                </td>
                                <td className="w100">
                                  <FormInput
                                    type="number"
                                    noSize
                                    min="0"
                                    step={getStepQuantidade(item.produto)}
                                    erroMensagem={_.get(
                                      errors,
                                      `produtos[${index}].estoqueAtual`,
                                    )}
                                    name={`produtos[${index}].estoqueAtual`}
                                    value={item.estoqueAtual}
                                    onChange={(name, value) =>
                                      this.handleQuantidadeChange(
                                        setFieldValue,
                                        name,
                                        value,
                                        item.produto,
                                      )
                                    }
                                    disabled={
                                      isFinalizado ||
                                      this.state.salvandoPedidoEmMapa ||
                                      (item.produto && item.produto.bloqueado)
                                    }
                                  />
                                </td>
                                <td className="w100">
                                  <FormInput
                                    type="number"
                                    noSize
                                    min="0"
                                    step={getStepQuantidade(item.produto)}
                                    id={`produtos${index}qtdSolicitar`}
                                    erroMensagem={_.get(
                                      errors,
                                      `produtos[${index}].qtdSolicitar`,
                                    )}
                                    name={`produtos[${index}].qtdSolicitar`}
                                    value={item.qtdSolicitar}
                                    onChange={(name, value) =>
                                      this.handleQuantidadeChange(
                                        setFieldValue,
                                        name,
                                        value,
                                        item.produto,
                                      )
                                    }
                                    disabled={
                                      isFinalizado ||
                                      this.state.salvandoPedidoEmMapa ||
                                      (item.produto &&
                                        item.produto.bloqueado) ||
                                      item.estoqueTotal === 0
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>

                    {podeAdicionarProduto && (
                      <div className="form-row mt-3">
                        <div className="form-group col-md-10">
                          <SelectInput
                            name="produtoNovoSelecionado"
                            id="produtoNovoSelecionado"
                            label="Adicionar novo produto ao pedido"
                            placeholder="Selecione o produto"
                            valueKey="id"
                            labelKey="label"
                            noSize={true}
                            returnFullObject={true}
                            isMulti={false}
                            searchable={true}
                            minSearchLength={3}
                            debounceMs={500}
                            allowSelectAll={false}
                            options={produtosDisponiveis}
                            parent={values.cliente}
                            onFetchData={async (termo, cliente) => {
                              const response = await produtoService.buscarPorCliente(
                                termo,
                                cliente || values.cliente,
                              );
                              const pagina = response && response.data;
                              const encontrados = Array.isArray(pagina)
                                ? pagina
                                : pagina && Array.isArray(pagina.content)
                                ? pagina.content
                                : [];
                              const idsSelecionados = (values.produtos || [])
                                .map((item) => item && item.idProduto)
                                .filter(Boolean);

                              return {
                                data: encontrados.filter(
                                  (produto) =>
                                    produto &&
                                    idsSelecionados.indexOf(produto.id) === -1,
                                ),
                              };
                            }}
                            value={this.state.produtoNovoSelecionado}
                            disabled={
                              this.state.verificandoProdutoNovo ||
                              this.state.salvandoPedidoEmMapa
                            }
                            onChange={(name, value) => {
                              this.setState({
                                produtoNovoSelecionado: value,
                              });
                              this.adicionarProdutoExtraComEstoque(
                                value,
                                values,
                                setFieldValue,
                              );
                            }}
                          />
                        </div>
                      </div>
                    )}

                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <FormInput
                          label="Responsável"
                          noSize
                          id="responsavel"
                          disabled={
                            isFinalizado || this.state.salvandoPedidoEmMapa
                          }
                          type="text"
                          name="responsavel"
                          value={values.responsavel}
                          onChange={setFieldValue}
                          erroMensagem={errors.responsavel}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <CpfInput
                          placeholder="Digite o CPF"
                          erroMensagem={errors.cpfResponsavel}
                          id="cpfResponsavel"
                          name="cpfResponsavel"
                          value={values.cpfResponsavel}
                          onChange={setFieldValue}
                          noSize={true}
                          label="CPF do responsável"
                          disabled={
                            isFinalizado || this.state.salvandoPedidoEmMapa
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="d-flex flex-row flex-sm-row ">
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="button"
                          className="btn btn-secondary btn30 white"
                          disabled={
                            isSubmitting || this.state.salvandoPedidoEmMapa
                          }
                          onClick={() => this.props.history.goBack()}
                        >
                          Cancelar
                        </button>
                      </div>

                      {isEdit && (
                        <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                          <button
                            type="button"
                            className="btn btn-danger btn30"
                            disabled={
                              isSubmitting ||
                              this.state.salvandoPedidoEmMapa ||
                              isFinalizado
                            }
                            onClick={() => {
                              if (this.state.salvandoPedidoEmMapa) {
                                return;
                              }

                              confirmAlert({
                                customUI: ({ onClose }) => (
                                  <div className="custom-confirm-alert">
                                    <h2>Confirmar exclusão</h2>
                                    <p>
                                      Você tem certeza que deseja excluir este
                                      Pedido em Mapa?
                                    </p>
                                    <div className="d-flex justify-content-around mt-4">
                                      <button
                                        className="btn btn-secondary btn30 white"
                                        onClick={onClose}
                                      >
                                        Não
                                      </button>
                                      <button
                                        className="btn btn-danger btn30"
                                        onClick={async () => {
                                          try {
                                            await pedidoEmMapaService.doDelete(
                                              values.id,
                                            );
                                            this.props.success({
                                              message:
                                                'Pedido em mapa excluído com sucesso.',
                                            });
                                            this.props.history.push(
                                              '/pedidoEmMapa',
                                            );
                                            onClose();
                                          } catch (e) {
                                            console.error(e);
                                            this.props.error({
                                              message:
                                                'Erro ao excluir o Pedido em mapa',
                                            });
                                            onClose();
                                          }
                                        }}
                                      >
                                        Sim
                                      </button>
                                    </div>
                                  </div>
                                ),
                              });
                            }}
                          >
                            Excluir
                          </button>
                        </div>
                      )}

                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="submit"
                          className="btn btn-secondary btn30 green"
                          disabled={
                            isSubmitting ||
                            this.state.salvandoPedidoEmMapa ||
                            (values.produtos || []).length === 0 ||
                            isFinalizado
                          }
                        >
                          {this.state.salvandoPedidoEmMapa ? (
                            <React.Fragment>
                              <span
                                className="spinner-border spinner-border-sm mr-2"
                                role="status"
                                aria-hidden="true"
                              />
                              <span>Enviando...</span>
                            </React.Fragment>
                          ) : entity && entity.id ? (
                            'Salvar Alterações'
                          ) : (
                            'Salvar'
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const user = state && state.authentication ? state.authentication.user : null;
  const load = state && state.load ? state.load.load : false;
  const message = state && state.load ? state.load.message : '';
  return { user, loading: load, messageLoading: message };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load, message = '') => loading({ load, message }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  { forwardRef: true },
)(PedidoEmMapaEdit);
